import {createApi} from './_factory'
import type {CommonNs, FeatureNs, IntegrationNs} from '@shared/types'

const api = createApi('feature')

export const AzureApi = {
  sendFeatureToAzure: (data: IntegrationNs.IntegrationInfoRequest) =>
    api.post<IntegrationNs.IntegrationInfoRequest, void>('send-feature-to-azure', data),

  sendFeatures: (data: FeatureNs.SendToAzureRequest) =>
    api.post<FeatureNs.SendToAzureRequest, CommonNs.AnyResponse>('send-feature-to-azure', data),
}
